<app-period [default]="1" (myDates)="refresh($event)"></app-period>
<p-table #dtQuotes [value]="quotes" *ngIf="quotes" sortField="NumberSuffix" [sortOrder]="-1" styleClass="p-datatable-gridlines p-datatable-striped p-datatable-sm">
  <ng-template pTemplate="header">
    <tr>
      <th [pSortableColumn]="'DocumentNumber'">Ref.<p-sortIcon [field]="'DocumentNumber'"></p-sortIcon></th>
      <th [pSortableColumn]="'CustomerName'">Client<p-sortIcon [field]="'CustomerName'"></p-sortIcon></th>
      <th [pSortableColumn]="'DeliveryAddress_City'">Ville livraison<p-sortIcon [field]="'DeliveryAddress_City'"></p-sortIcon></th>
      <th [pSortableColumn]="'xx_Code_Festival'" style="width: 150px">Festival<p-sortIcon [field]="'xx_Code_Festival'"></p-sortIcon></th>
      <th [pSortableColumn]="'Colleague'">Commercial<p-sortIcon [field]="'CustomerName'"></p-sortIcon></th>
      <th [pSortableColumn]="'DocumentDate.date'"> Date de création<p-sortIcon [field]="'DocumentDate.date'"></p-sortIcon></th>
      <th [pSortableColumn]="'DeliveryDate.date'"> Date de livraison<p-sortIcon [field]="'DeliveryDate.date'"></p-sortIcon></th>
      <th>Date de passage en commande</th>
      <th>Transféré vers</th>
      <th></th>
    </tr>
    <tr>
      <th>
        <input pInputText type="text" placeholder="Filtrer par ref" (input)="dtQuotes.filter($event.target.value, 'DocumentNumber', 'contains')">
      </th>
      <th><input  pInputText type="text" placeholder="Filtrer par client" (input)="dtQuotes.filter($event.target.value, 'CustomerName', 'contains')"></th>
      <th><input pInputText type="text" placeholder="Filtrer par ville" (input)="dtQuotes.filter($event.target.value, 'DeliveryAddress_City', 'contains')"></th>
      <th style="width: 150px"><input style="width: 100px" pInputText type="text" placeholder="Filtrer par code" (input)="dtQuotes.filter($event.target.value, 'xx_Code_Festival', 'contains')"></th>
      <th><input pInputText type="text" placeholder="Filtrer par commercial" (input)="dtQuotes.filter($event.target.value, 'ColleagueId', 'contains')"></th>
      <th></th>
      <th></th>
    </tr>
    <tr *ngFor="let row of unregistered">
      <th>
        <div class="flex gap-2">
          <p-message severity="warn" text="En cours d'importation"></p-message>
          <i class="fa fa-refresh" (click)="refresh(event)" style="margin-left: 10px; font-size: 1.3rem; cursor: pointer;"></i>
        </div>
      </th>
      <th>{{row.customer.Name}}</th>
      <th></th>
      <th></th>
      <th>{{row.date | date}}</th>
      <th></th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-item>
    <tr [ngClass]="{'opacity-50':item.TransferedDocumentNumber != null || item.DocumentState == 3}">
      <td>
        <a (click)="show(item)" style="cursor: pointer;">
          <u>{{item.DocumentNumber}}</u>
          <i class="fa fa-eye" style="margin-left: 10px; font-size: 1.3rem"></i>
        </a>
        <a target="blank" href="https://ws.blackrockgames.fr/pdf.php?file={{item.DocumentNumber}}">
          <i class="pi pi-file-pdf" style="margin-left: 10px; font-size: 1.3rem"></i>
        </a>
      </td>
      <td>{{item.CustomerName}}</td>
      <td>{{item.DeliveryAddress_City}}</td>
      <td>{{item.xx_Code_Festival}}</td>
      <td>{{item.ColleagueId}}</td>
      <td>{{item.DocumentDate.date | date}}</td>
      <td>{{item.DeliveryDate != null ? (item.DeliveryDate.date | date) : ''}}</td>
      <td>{{item.cmDate ? (item.cmDate | date) : ''}}</td>
      <td>{{item.TransferedDocumentNumber}}<i *ngIf="item.DocumentState == '3' && item.TransferedDocumentNumber == null ">En cours</i></td>
      <td>
        <div class="flex gap-2">
          <button class="p-button-sm" (click)="edit(item)" [disabled]="item.TransferedDocumentNumber != null || item.DocumentState == 3" pButton label="Modifier" ></button>
          <button class="p-button-info p-button-sm" (click)="passQuote(item)" [disabled]="item.TransferedDocumentNumber != null || item.DocumentState == 3" pButton label="Passer en commande maintenant" ></button>
          <button class="p-button-warning p-button-sm" (click)="delete(item)" [disabled]="item.TransferedDocumentNumber != null || item.DocumentState == 3" pButton label="supprimer" ></button>
        </div>
      </td>
    </tr>
    <tr *ngIf="alerts[item.CustomerId]" [ngClass]="{'opacity-50':item.TransferedDocumentNumber != null || item.DocumentState == 3}">
      <td colspan="10" style="background-color: #fed352;" class="text-100  ">
        <div *ngFor="let row of alerts[item.CustomerId]"><b><i>{{row.summary}} : </i></b><span [innerHtml]="row.detail"></span></div>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-dialog [(visible)]="displayQuote" [modal]="true" [style]="{width: '900px'}" [position]="'top'">
  <ng-container *ngIf="quote">
    <div class="grid mb-3">
      <div class="col-12 md:col-6">
        <h4 class="mt-0 mb-2">Adresse de facturation</h4>
        <div class="text-900 line-height-3">
          <div *ngIf="quote.InvoicingAddress_ThirdName"><b>{{quote.InvoicingAddress_ThirdName}}</b></div>
          <div *ngIf="quote.InvoicingContact_Name || quote.InvoicingContact_FirstName">
            {{quote.InvoicingContact_FirstName}} {{quote.InvoicingContact_Name}}
          </div>
          <div *ngIf="quote.InvoicingAddress_Address1">{{quote.InvoicingAddress_Address1}}</div>
          <div *ngIf="quote.InvoicingAddress_Address2">{{quote.InvoicingAddress_Address2}}</div>
          <div *ngIf="quote.InvoicingAddress_Address3">{{quote.InvoicingAddress_Address3}}</div>
          <div *ngIf="quote.InvoicingAddress_ZipCode || quote.InvoicingAddress_City">
            {{quote.InvoicingAddress_ZipCode}} {{quote.InvoicingAddress_City}}
          </div>
          <div *ngIf="quote.InvoicingAddress_CountryIsoCode">{{quote.InvoicingAddress_CountryIsoCode}}</div>
          <div *ngIf="quote.InvoicingContact_Email" class="mt-1">{{quote.InvoicingContact_Email}}</div>
          <div *ngIf="quote.InvoicingContact_Phone || quote.InvoicingContact_CellPhone">
            {{quote.InvoicingContact_Phone || quote.InvoicingContact_CellPhone}}
          </div>
        </div>
      </div>
      <div class="col-12 md:col-6">
        <h4 class="mt-0 mb-2">Adresse de livraison</h4>
        <div class="text-900 line-height-3">
          <div *ngIf="quote.DeliveryAddress_ThirdName"><b>{{quote.DeliveryAddress_ThirdName}}</b></div>
          <div *ngIf="quote.DeliveryContact_Name || quote.DeliveryContact_FirstName">
            {{quote.DeliveryContact_FirstName}} {{quote.DeliveryContact_Name}}
          </div>
          <div *ngIf="quote.DeliveryAddress_Address1">{{quote.DeliveryAddress_Address1}}</div>
          <div *ngIf="quote.DeliveryAddress_Address2">{{quote.DeliveryAddress_Address2}}</div>
          <div *ngIf="quote.DeliveryAddress_Address3">{{quote.DeliveryAddress_Address3}}</div>
          <div *ngIf="quote.DeliveryAddress_ZipCode || quote.DeliveryAddress_City">
            {{quote.DeliveryAddress_ZipCode}} {{quote.DeliveryAddress_City}}
          </div>
          <div *ngIf="quote.DeliveryAddress_CountryIsoCode">{{quote.DeliveryAddress_CountryIsoCode}}</div>
          <div *ngIf="quote.DeliveryContact_Email" class="mt-1">{{quote.DeliveryContact_Email}}</div>
          <div *ngIf="quote.DeliveryContact_Phone || quote.DeliveryContact_CellPhone">
            {{quote.DeliveryContact_Phone || quote.DeliveryContact_CellPhone}}
          </div>
        </div>
      </div>
    </div>

    <p-table [value]="quote.lines" [autoLayout]="true">
      <ng-template pTemplate="header">
        <tr>
          <th colspan="3">Notes</th>
        </tr>
        <tr>
          <th colspan="3">{{quote.NotesClear}}</th>
        </tr>
        <tr>
          <th>Id</th>
          <th>Article</th>
          <th>Quantité</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-item>
        <tr>
          <td>{{item.ItemId}}</td>
          <td>{{item.DescriptionClear}}</td>
          <td>{{item.Quantity | number:'1.0-0'}}</td>
        </tr>
      </ng-template>
    </p-table>
  </ng-container>
</p-dialog>